/**
 * Safely stringify anything, stripping out circular references.
 * @param obj  any JS object
 * @param space  number of spaces for pretty‑print (default 2)
 */
export function safeStringify(obj: unknown, space = 2): string {
  const seen = new WeakSet<object>();
  return JSON.stringify(obj, function replacer(_key, value) {
    if (value && typeof value === 'object') {
      if (seen.has(value)) {
        return '[Circular]';
      }
      seen.add(value);
    }
    return value;
  }, space);
}


/**
 * Safely stringifies multiple input values using the `safeStringify` function.
 *
 * @param args - A variable number of values to be stringified.
 * @returns An array of stringified representations of the input values.
 *
 * @remarks
 * This function applies `safeStringify` to each argument provided and returns an array of the results.
 * It is useful for safely converting multiple values to their string representations, especially when
 * dealing with values that may not be serializable by `JSON.stringify`.
 *
 * @see {@link safeStringify}
 */
export function safeStringifyMultiple(...args: unknown[]): string[] {
  return args.map(arg => safeStringify(arg));
}